import React, { memo, useCallback, useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useGlobalSearchParams, useLocalSearchParams } from "expo-router";

import ViewProduct from "../../index";

const ShopProduct = ({}) => {
    const local = useGlobalSearchParams();

    const selectedFilters = useSelector((state) => state.FilterReducer.selectedFilters, shallowEqual);

    const dispatch = useDispatch();

    return <ViewProduct productIdProp={local?.productId} />;
};

export default ShopProduct;
